module.exports = __webpack_public_path__ + "media/images/icon/complete-order-e504694e8537087ceb7854151283974a.svg";